import React, { Fragment, useEffect, useState } from "react";
import { Col, Card, CardHeader, CardBody, Form, FormGroup, Label, Row } from 'reactstrap';
import { Btn, H3, Breadcrumbs } from "../../../AbstractElements";
import { useForm, Controller } from 'react-hook-form';
import { useLocation, useNavigate } from 'react-router-dom';
import { AreaCodeError, AreaNameError, Coupon, CouponAdd, CouponCode, CouponName, CustomerLogin, DiscountT, EndDate, Save, ShippingFree, StartDate, Total, Type, UserPerCoupon, UserPerCustomer } from "../../../Constant";
import { addCoupon, addCouponRole, editCoupon, editCouponRole, uploadCoupon, uploadCouponRole, viewCoupon, viewCouponRole } from "../../../CommonUrl";
import { useSelector } from "react-redux";
import { getClientUrlDataToken, postClientUrlWithToken } from "../../../Utils/restUtils";
import { toast } from 'react-toastify';
import Transparentspinner from "../../Common/Loader/Transparentspinner";
import Typeahead from "../../../CommonElements/TypeAhead";
import DatePicker from 'react-datepicker';
import moment from "moment";

const CouponEdit = () => {
    const { register, handleSubmit, control, formState: { errors }, setValue } = useForm({
        defaultValues: {}
    });
    const location = useLocation();
    const authState = useSelector((state) => state.auth);
    const searchParams = location.search;
    const params = new URLSearchParams(searchParams);
    const param1 = params.get("id");
    const [loading, setLoading] = useState(false);
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const navigate = useNavigate();
    const options = [
        { value: 'cash', label: 'Cash' },
        { value: 'percentage', label: 'Percentage' },
    ];

    useEffect(() => {
        getAreaData();
    }, []);

    const getAreaData = async () => {
        setLoading(true);
        const data = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? editCoupon + `?coupon_id=${param1}` : editCouponRole + `?coupon_id=${param1}`);
        if (data.status === true) {
            setValue('couponName', data.data?.name);
            setValue('couponCode', data.data?.code);
            setValue('discount', data.data?.discount);
            setValue('total', data.data?.min_amount);
            setValue('userPerCoupon', data.data?.use_per_coupon);
            setValue('userPerCustomer', data.data?.use_per_customer);
            setValue('shippingFree', data.data?.free_shipping);
            setValue('customerLogin', data.data?.customer_login);

            const typeValue = data.data?.type || '';
            const capitalizedType = typeValue.charAt(0).toUpperCase() + typeValue.slice(1);
            setValue('type', { label: capitalizedType, value: typeValue });

            const start_dates = data.data.start_date;
            if (start_dates) {
                setStartDate(new Date(start_dates));
            }

            const end_dates = data.data.end_date;
            if (end_dates) {
                setEndDate(new Date(end_dates));
            }
        } else if (data.status >= 400 && data.status <= 405) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
        } else if (data.status >= 500 && data.status <= 505) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
        } else {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
        }
        setLoading(false);
    }

    const handleChangeDate = date => {
        setStartDate(date);
    };

    const handleChangeEndDate = date => {
        setEndDate(date);
    };

    const onSubmit = async (data) => {
        const payload = {
            ...data,
            startDate,
            endDate,
        };
        setLoading(true);
        const postRequest = {
            coupon_id: param1, name: payload.couponName, code: payload.couponCode, type: payload.type?.value, discount: payload.discount,
            start_date: moment(startDate).format('YY/MM/DD'), end_date: moment(endDate).format('YY/MM/DD'),
            min_amount: payload.total, free_shipping: payload.shippingFree, customer_login: payload.customerLogin,
            use_per_customer: payload.userPerCustomer, use_per_coupon: payload.userPerCoupon,
        }
        const addAreaResponse = await postClientUrlWithToken(authState.apiUrl, authState.userRole === 1 ? uploadCoupon : uploadCouponRole, postRequest);
        if (addAreaResponse.status === 200) {
            if (addAreaResponse.data.status === true) {
                toast.success(addAreaResponse.data.message)
                navigate(`${process.env.PUBLIC_URL}/settings/coupon`);
            } else {
                toast.error(addAreaResponse.data.message)
                setLoading(false);
            }
        } else if (addAreaResponse.status >= 400 && addAreaResponse.status <= 405) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
        } else if (addAreaResponse.status >= 500 && addAreaResponse.status <= 505) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
        } else {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
        }
        setLoading(false);
    };
    return (
        <Fragment>
            {loading && (
                <Transparentspinner />
            )}
            <Breadcrumbs mainTitle={Coupon} parent="Settings" title={Coupon} />
            <Card>
                <CardHeader className="pb-0">
                    <H3>{CouponAdd}</H3>
                </CardHeader>
                <CardBody>
                    <Form className="needs-validation" noValidate onSubmit={handleSubmit(onSubmit)}>
                        <Row className="g-3 pt-3">
                            <Col md='6'>
                                <Label className="form-label" for="couponName">{CouponName}<span className="requireStar">*</span></Label>
                                <input className="form-control" id="couponName" type="text" {...register('couponName', { required: true })} />
                                <span className="text-danger">{errors.areaname && AreaNameError}</span>
                            </Col>
                            <Col md="6">
                                <Label className="form-label" for="couponCode">{CouponCode} <span className="requireStar">*</span></Label>
                                <input className="form-control" id="couponCode" type="text" {...register('couponCode', { required: true })} />
                                <span className="text-danger">{errors.areacode && AreaCodeError}</span>
                            </Col>
                        </Row>
                        <Row className="g-3 pt-3">
                            <Col md="6">
                                <Label className="form-label" >{Type} <span className="requireStar">*</span></Label>
                                <Controller
                                    name="type"
                                    control={control}
                                    render={({ field }) => (
                                        <Typeahead
                                            options={options}
                                            onChange={(value) => {
                                                field.onChange(value);
                                            }}
                                            value={field.value}
                                        />
                                    )}
                                />
                                <p className="text-danger">{errors.type?.message}</p>
                            </Col>
                            <Col md="6">
                                <Label className="form-label" for="discount">{DiscountT} <span className="requireStar">*</span></Label>
                                <input className="form-control" id="discount" type="text" {...register('discount', { required: true })} />
                                <span className="text-danger">{errors.areacode && AreaCodeError}</span>
                            </Col>
                        </Row>
                        <Row className="g-3 pt-3">
                            <Col md='6'>
                                <Label className="form-label" for="total">{Total}<span className="requireStar">*</span></Label>
                                <input className="form-control" id="total" type="text" {...register('total', { required: true })} />
                                <span className="text-danger">{errors.areaname && AreaNameError}</span>
                            </Col>
                            <Col md="3">
                                <FormGroup className="mb-3">
                                    <Label className="form-label" for="date">{StartDate} <span className="requireStar">*</span></Label>
                                    <Col xl='12' md="12" sm='12'>
                                        <DatePicker
                                            id="date"
                                            style={{ padding: '12px 100px' }}
                                            className="form-control "
                                            dateFormat="dd/MM/yyyy"
                                            placeholderText="dd/mm/yyyy"
                                            onChange={handleChangeDate}
                                            // peekNextMonth
                                            selected={startDate}
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            required
                                        />
                                    </Col>
                                </FormGroup>
                            </Col>
                            <Col md="3">
                                <FormGroup className="mb-3">
                                    <Label className="form-label" for="enddate">{EndDate} <span className="requireStar">*</span></Label>
                                    <Col xl='12' md="12" sm='12'>
                                        <DatePicker
                                            id="enddate"
                                            style={{ padding: '12px 100px' }}
                                            className="form-control "
                                            dateFormat="dd/MM/yyyy"
                                            placeholderText="dd/mm/yyyy"
                                            onChange={handleChangeEndDate}
                                            // peekNextMonth
                                            selected={endDate}
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            required
                                        />
                                    </Col>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row className="g-3 pt-3">
                            <Col md='6'>
                                <Label className="form-label" for="userPerCoupon">{UserPerCoupon}<span className="requireStar">*</span></Label>
                                <input className="form-control" id="userPerCoupon" type="text" {...register('userPerCoupon', { required: true })} />
                                <span className="text-danger">{errors.areaname && AreaNameError}</span>
                            </Col>
                            <Col md='6'>
                                <Label className="form-label" for="userPerCustomer">{UserPerCustomer}<span className="requireStar">*</span></Label>
                                <input className="form-control" id="userPerCustomer" type="text" {...register('userPerCustomer', { required: true })} />
                                <span className="text-danger">{errors.areaname && AreaNameError}</span>
                            </Col>
                        </Row>
                        <Row className="g-3 pt-3">
                            <Col md="6">
                                <FormGroup className="mb-3">
                                    <Label>{ShippingFree} <span className="requireStar">*</span></Label>
                                    <Col xl='12' md="12" sm='12'>
                                        <label htmlFor="field-yes" style={{ marginRight: '30px' }}>
                                            <input
                                                {...register("shippingFree")}
                                                type="radio"
                                                className="radio_animated"
                                                value="yes"
                                                id="field-yes"
                                            />
                                            Yes
                                        </label>
                                        <label htmlFor="field-no">
                                            <input
                                                {...register("shippingFree")}
                                                type="radio"
                                                className="radio_animated"
                                                value="no"
                                                id="field-no"
                                            />
                                            No
                                        </label>
                                        {errors.shippingFree && <span className="text-danger">Shipping selection is required</span>}
                                    </Col>
                                </FormGroup>
                            </Col>
                            <Col md="6">
                                <FormGroup className="mb-3">
                                    <Label>{CustomerLogin} <span className="requireStar">*</span></Label>
                                    <Col xl='12' md="12" sm='12'>
                                        <label htmlFor="field-yes" style={{ marginRight: '30px' }}>
                                            <input
                                                {...register("customerLogin")}
                                                type="radio"
                                                className="radio_animated"
                                                value="yes"
                                                id="field-yes"
                                            />
                                            Yes
                                        </label>
                                        <label htmlFor="field-no">
                                            <input
                                                {...register("customerLogin")}
                                                type="radio"
                                                className="radio_animated"
                                                value="no"
                                                id="field-no"
                                            />
                                            No
                                        </label>
                                        {errors.customerLogin && <span className="text-danger">Login option is required</span>}
                                    </Col>
                                </FormGroup>

                            </Col>
                        </Row>
                        <FormGroup>
                        </FormGroup>
                        <Btn attrBtn={{ color: "primary" }} type="submit">{Save}</Btn>
                    </Form>
                </CardBody>
            </Card>
        </Fragment>
    )
}
export default CouponEdit;